module.exports = __webpack_public_path__ + "img/034-hydro-power.60958cc7.svg";